import { useCallback, useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { AllCategoryMultiLevelCategory } from '../../@types/product';
import { getFestivals } from '../../api/login';
import { getDetailCategories, getFilterList } from '../../api/product';
import ProductItem from '../../components/festival/ProductItem';
import ProductListItem from '../../components/festival/ProductListItem';
import ProductCenterModal from '../../components/product/ProductCenterModal';
import ProductFilterCenterModal from '../../components/product/ProductFilterCenterModal';
import ProductFilterModal from '../../components/product/ProductFilterModal';
import ProductHeader from '../../components/product/ProductHeader';
import ProductModal from '../../components/product/ProductModal';
import ProductSortModal from '../../components/product/ProductSortModal';
import '../../css/Product.css';
import { delPrevList, delPrevPage, delPrevScroll, getPrevList, getPrevPage, getPrevScroll } from '../../js/script';
import { imgURL } from '../Home';
import Category from './Category';
import CategoryFourDepth from './CategoryFourDepth';

// 이미지 경로

export default function FestivalCategory() {
  const [listItem, setListItem] = useState<any>([]); //상품 아이템
  const [listItems, setListItems] = useState<any>([]);
  const [totalCount, setTotalCount] = useState<number>(0); //상품 리스트 개수
  const [twoDepCategoryNo, setTwodepCategoryNo] = useState<number>();
  const [twoDepCategory, setTwodepCategory] = useState<AllCategoryMultiLevelCategory[]>([]);
  const [threeDepCategoryNo, setThreedepCategoryNo] = useState<number>();
  const [threeDepCategory, setThreedepCategory] = useState<AllCategoryMultiLevelCategory[]>([]);
  const [fourDepCategoryNo, setfourDepCategoryNo] = useState<number>();
  const [fourDepCategory, setFourdepCategory] = useState<AllCategoryMultiLevelCategory[]>([]);
  const [isModal, setIsModal] = useState(false);
  const [selectProductNo, setSelectProductNo] = useState<string>('');
  const [type, setType] = useState<string>('thumb');
  const [sortKeyword, setSortKeyword] = useState<string>('RECENT_PRODUCT'); //정렬값
  const [sortKeywordLabel, setSortKeywordLabel] = useState<string>('최신순'); //정렬 텍스트
  const [sortDirection, setSortDirection] = useState<string>('DESC'); //정렬 내림차순?오름차순
  const [isSort, setIsSort] = useState(false); //정렬 팝업열기
  const [isFilter, setIsFilter] = useState(false); //필터 팝업열기
  const [getMax, setGetMax] = useState<number>(1000000);
  const [getMin, setGetMin] = useState<number>(0);
  const [freeCheck, setFreeCheck] = useState(false);
  const [filterApply, setFilterApply] = useState(false);
  const [brandArray, setBrandArray] = useState<any>([]);
  const [filterTotal, setFilterTotal] = useState(0);
  const [filterMin, setFilterMin] = useState(0);
  const [filterMax, setFilterMax] = useState(1000000);
  const [one, setOne] = useState<AllCategoryMultiLevelCategory>();
  const [max, setMax] = useState(1000000);
  const [min, setMin] = useState(0);
  const [thirdDepLabel, setThirdDepLabel] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1); //현재 페이지
  const [changeKeyword, setChangeKeyword] = useState<boolean>(false);
  const [festivalData, setFestivalData] = useState<any>([]);
  const [selectData, setSelectData] = useState<any>([]);

  const obsRef = useRef(null); //observer Element
  const preventRef = useRef(true); //옵저버 중복 실행 방지
  const endRef = useRef(false); //모든 글 로드 확인
  const listItemRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const param = useParams();

  useEffect(() => {
    if (location.state) {
      getFestivals(location.state.path).then((res) => {
        setFestivalData(res.data.festival.shopbyFestivalComponents);
      });
    }
  }, [location.state]);

  useEffect(() => {
    if (festivalData) {
      const horizontalScrollData = festivalData.find((el: any) => el.type === 'horizontal-scroll');

      if (horizontalScrollData) {
        setSelectData(horizontalScrollData);
      }
    }
  }, [festivalData]);

  useEffect(() => {
    setListItem([]);
    setLoading(false);
    setTimeout(() => {
      setSortDirection('DESC');
      setType('thumb');
      setSortKeyword('RECENT_PRODUCT');
      setSortKeywordLabel('최신순');
      setPage(1);
      preventRef.current = true;
    }, 400);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 400);
  }, []);

  useEffect(() => {
    if (threeDepCategory) {
      const matchedCategory = threeDepCategory.find((el: any) => Number(el.categoryNo) === Number(threeDepCategoryNo));

      if (matchedCategory) {
        setThirdDepLabel(matchedCategory.label);
      }
    }
  }, [threeDepCategoryNo, threeDepCategory]);

  useEffect(() => {
    setPage(1);
    endRef.current = false;
    setChangeKeyword((prev: boolean) => !prev);
  }, [type, sortKeyword, sortDirection, filterApply]);

  const getPost = useCallback(async () => {
    if (fourDepCategoryNo) {
      //글 불러오기
      try {
        getFilterList(
          sortKeyword,
          page,
          Number(fourDepCategoryNo),
          sortDirection,
          brandArray.join(','),
          getMin,
          getMax,
          freeCheck,
        )
          .then((res) => {
            if (page === 1) {
              setListItems(res.data.items);
              endRef.current = false;
            } else {
              setListItems((prev: any) => [...prev, ...res.data.items]);
            }

            setTotalCount(res.data.totalCount);
            if (res.data.pageCount <= page) {
              //마지막 페이지일 경우
              endRef.current = true;
            }
          })
          .catch((err) => console.log(err));
      } catch (e) {
        console.log(e);
      }
    }
  }, [page, fourDepCategoryNo, changeKeyword]);

  useEffect(() => {
    if (listItems) {
      const unique = removeDuplicatesByProductNo(listItems);
      setListItem(unique);
    }
  }, [listItems]);

  function removeDuplicatesByProductNo(arr: any) {
    const seen = new Set();
    return arr.filter((item: any) => {
      if (seen.has(item.productNo)) {
        return false;
      } else {
        seen.add(item.productNo);
        return true;
      }
    });
  }

  useEffect(() => {
    const val = getPrevScroll();
    const list = getPrevList();
    const page = getPrevPage();
    if (page === undefined) {
      window.sessionStorage.removeItem('prevPageVal');
      return;
    }
    if (list === undefined) {
      window.sessionStorage.removeItem('prevListVal');
      return;
    }

    if (val && list && page && list.length > 0) {
      setListItems(list);
      setPage(Number(page));

      setTimeout(() => {
        //window.scrollTo(0, Number(val));
        delPrevList();
        delPrevScroll();
        delPrevPage();
        // console.log(`실행 ${page}`);
        preventRef.current = true; //옵저버 중복 실행 방지
      }, 500);
    } else {
      preventRef.current = true;
      getPost();
      // console.log(`실행 ${page}`);
    }
  }, [page, fourDepCategoryNo, changeKeyword]);

  useEffect(() => {
    setBrandArray([]);
    setFilterApply(false);
    setFilterTotal(0);
    setFilterMin(0);
    setFilterMax(1000000);
    setGetMax(1000000);
    setGetMin(0);
    setFreeCheck(false);
    setTimeout(() => {
      setFilterApply((prev: boolean) => !prev);
    }, 200);
  }, [location]);

  useEffect(() => {
    if (filterApply && !isFilter) {
      setFilterMin(getMin);
      setFilterMax(getMax);
    }
  }, [isFilter, filterApply]);

  useEffect(() => {
    if (filterApply) {
      if (brandArray || freeCheck) {
        if (freeCheck) {
          setFilterTotal(brandArray.length + 1);
        } else {
          setFilterTotal(brandArray.length);
        }
      }
      if (getMax !== 1000000 || getMin !== 0) {
        setFilterTotal((prev: number) => prev + 1);
      }
    }
  }, [brandArray, freeCheck, filterMax, filterMin, getMin, getMax, filterApply]);
  // 상품목록에서 필터갯수 오류 수정

  useEffect(() => {
    setThreedepCategoryNo(Number(param.threeDepno));
    setTwodepCategoryNo(Number(param.twoDepno));
    setfourDepCategoryNo(Number(param.fourDepno));
  }, [param]);

  useEffect(() => {
    if (isFilter) {
      setFilterApply(false);
    }
  }, [isFilter]);

  useEffect(() => {
    const footer = document.querySelector('.footer_wrap') as HTMLElement;
    if (isMobile) {
      footer.style.paddingBottom = '36px';
    }
  }, [location.pathname]);

  //카테고리 관련(3뎁스 가져오기)
  useEffect(() => {
    if (twoDepCategoryNo) {
      getDetailCategories(twoDepCategoryNo)
        .then((res) => {
          const categories = res.data.multiLevelCategories[0]?.children;

          if (categories) {
            setThreedepCategory(categories[0]?.children);

            const matchedCategory = categories.find((el: any) => el.categoryNo === twoDepCategoryNo);
            if (matchedCategory) {
              setOne(res.data.multiLevelCategories[0]);
              setTwodepCategory(matchedCategory);
            }
          }
        })
        .catch((err) => console.error('Error fetching detail categories:', err));
    }
  }, [twoDepCategoryNo]);
  //카테고리 관련(4뎁스)
  useEffect(() => {
    if (threeDepCategoryNo) {
      const array: any = [{ categoryNo: threeDepCategoryNo, label: '전체' }];

      getDetailCategories(threeDepCategoryNo)
        .then((res) => {
          const categories = res.data.flatCategories;

          categories.forEach((el: any) => {
            if (Number(el.depth4CategoryNo) !== 0) {
              array.push({
                categoryNo: el.depth4CategoryNo,
                label: el.depth4Label,
              });
            }
          });

          setFourdepCategory(array);
        })
        .catch((err) => console.error('Error fetching detail categories:', err));
    }
  }, [threeDepCategoryNo]);

  useEffect(() => {
    if (listItem) {
      //옵저버 생성
      const observer = new IntersectionObserver(obsHandler, { threshold: 0.5 });
      if (obsRef.current) observer.observe(obsRef.current);
      return () => {
        observer.disconnect();
      };
    }
  }, [listItem, listItemRef]);

  const obsHandler = (entries: any) => {
    //옵저버 콜백함수
    const target = entries[0];
    if (!endRef.current && target.isIntersecting && preventRef.current) {
      //옵저버 중복 실행 방지
      preventRef.current = false; //옵저버 중복 실행 방지
      setPage((prev) => prev + 1); //페이지 값 증가
    }
  };

  return (
    <>
      <div className="main_wrap">
        <img
          src={isMobile ? selectData.mobileImageUrl : selectData.pcImageUrl}
          alt=""
          className="product_list_wrap product"
        />
        {/* 카테고리 */}
        <Category
          item={threeDepCategory}
          twoDepCategory={twoDepCategory}
          setThreedepCategoryNo={setThreedepCategoryNo}
          threeDepCategoryNo={threeDepCategoryNo}
          twoDepCategoryNo={twoDepCategoryNo}
          fourDepCategoryNo={fourDepCategoryNo}
          setFourDepCategoryNo={setfourDepCategoryNo}
        />

        {/* 카테고리 4dept */}
        {Number(twoDepCategoryNo) === Number(fourDepCategoryNo) ? null : (
          <CategoryFourDepth
            item={fourDepCategory}
            setFourDepCategoryNo={setfourDepCategoryNo}
            fourDepCategoryNo={fourDepCategoryNo}
            twoDepCategoryNo={twoDepCategoryNo}
            threeDepCategoryNo={threeDepCategoryNo}
          />
        )}

        {/* 상품 목록 전체 wrap */}
        <div className={location.pathname.includes('category') ? 'product_list_wrap product' : 'product_list_wrap'}>
          {/* 상품목록 header */}
          <ProductHeader
            totalCount={totalCount}
            type={type}
            setSortDirection={setSortDirection}
            sortDirection={sortDirection}
            setSortKeywordLabel={setSortKeywordLabel}
            setType={setType}
            isSort={isSort}
            setIsSort={setIsSort}
            sortKeyword={sortKeyword}
            setSortKeyword={setSortKeyword}
            sortKeywordLabel={sortKeywordLabel}
            setIsFilter={setIsFilter}
            filterTotal={filterTotal}
          ></ProductHeader>

          {/* 상품 Item Wrap */}

          {loading ? (
            brandArray || freeCheck || filterApply ? (
              listItem.length !== 0 ? (
                <>
                  <div className={type === 'thumb' ? 'product_wrap' : 'product_wrap list'} ref={listItemRef}>
                    {type === 'thumb' &&
                      listItem.map((el: any, idx: number) => {
                        return (
                          <ProductItem
                            item={el}
                            key={el.productNo}
                            setIsModal={setIsModal}
                            setSelectProductNo={setSelectProductNo}
                            page={page}
                            listItem={listItem}
                            one={one}
                            twoDepCategory={twoDepCategory}
                            thirdDepLabel={thirdDepLabel}
                            idx={idx}
                            totalCount={Number(totalCount)}
                          />
                        );
                      })}
                    {type === 'list' &&
                      listItem.map((el: any, idx: number) => {
                        return (
                          <ProductListItem
                            item={el}
                            listItem={listItem}
                            idx={idx}
                            key={el.productNo}
                            setIsModal={setIsModal}
                            setSelectProductNo={setSelectProductNo}
                            page={page}
                            one={one}
                            twoDepCategory={twoDepCategory}
                            thirdDepLabel={thirdDepLabel}
                          />
                        );
                      })}
                  </div>
                </>
              ) : (
                <div className="product_list_wrap empty">
                  <div className="no_data">
                    <img src={`${imgURL}/empty_logo.png`} alt="" />
                    <p>상품이 없습니다.</p>
                  </div>
                </div>
              )
            ) : (
              <div className="product_list_wrap">
                <div className="no_data">
                  <p className="tit_txt">상품이 없습니다.</p>
                  <p className="sub_txt">선택한 필터를 변경해 보세요.</p>
                  <button
                    className="btn_black"
                    onClick={() => {
                      setBrandArray([]);
                      setFreeCheck(false);
                      setGetMax(1000000);
                      setGetMin(0);
                      setFilterMax(1000000);
                      setFilterMin(0);
                      setFilterApply(true);
                    }}
                  >
                    필터 초기화
                  </button>
                </div>
              </div>
            )
          ) : null}
        </div>
        {isMobile && isSort ? (
          <ProductSortModal
            headerText="정렬"
            setIsModal={setIsSort}
            setSortKeyword={setSortKeyword}
            sortKeyword={sortKeyword}
            setSortKeywordLabel={setSortKeywordLabel}
            setSortDirection={setSortDirection}
            sortDirection={sortDirection}
          ></ProductSortModal>
        ) : null}
        {isModal ? (
          isMobile ? (
            <ProductModal
              setIsModal={setIsModal}
              listItem={listItem}
              headerText={'옵션선택'}
              selectProductNo={selectProductNo}
            ></ProductModal>
          ) : (
            <ProductCenterModal
              setIsModal={setIsModal}
              headerText={'옵션선택'}
              selectProductNo={selectProductNo}
              listItem={listItem}
            ></ProductCenterModal>
          )
        ) : null}
        {isFilter ? (
          isMobile ? (
            <ProductFilterModal
              isCategoryModal={isFilter}
              setIsCategoryModal={setIsFilter}
              setFreeCheck={setFreeCheck}
              setGetMax={setGetMax}
              setGetMin={setGetMin}
              setFilterApply={setFilterApply}
              setBrandArray={setBrandArray}
              brandArray={brandArray}
              freeCheck={freeCheck}
              max={max}
              filterMax={filterMax}
              setMax={setMax}
              min={min}
              filterMin={filterMin}
              setMin={setMin}
            ></ProductFilterModal>
          ) : (
            <ProductFilterCenterModal
              isCategoryModal={isFilter}
              setIsCategoryModal={setIsFilter}
              setFreeCheck={setFreeCheck}
              setGetMax={setGetMax}
              setGetMin={setGetMin}
              setFilterApply={setFilterApply}
              setBrandArray={setBrandArray}
              brandArray={brandArray}
              freeCheck={freeCheck}
              max={max}
              filterMax={filterMax}
              setMax={setMax}
              min={min}
              filterMin={filterMin}
              setMin={setMin}
            ></ProductFilterCenterModal>
          )
        ) : null}
      </div>
      <div ref={obsRef}></div>
      {/* <div ref={obsRef} style={{ height: "20px" }}></div> */}
    </>
  );
}
// 상품목록 헤더영역 wrap
export const ProductListHeder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;
  @media screen and (min-width: 768px) {
    padding: 14px 0;
  }
`;

export const ProductListNum = styled.div`
  color: var(--colGray6);
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  & span {
    color: var(--colBlack);
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }
`;

// 상품목록 헤더옵션(정렬, 필터, 상품목록 보기정렬 버튼)
export const ProductListOption = styled.ul`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & li {
    position: relative;
    & img {
    }
    @media screen and (min-width: 768px) {
      &:first-of-type {
      }
      &:nth-of-type(2) {
      }
      &:last-of-type {
      }
    }
    & .sort_layer {
      @media screen and (min-width: 768px) {
        position: absolute;
        top: 32px;
        right: 0;
        min-width: 135px;
        border-radius: 8px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
        background: var(--colWhite);
        z-index: 10;
        & ul {
          padding: 6px 32px 6px 16px;
          & li > a {
            display: block;
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
            color: var(--colGray5);
            padding: 10px 0;
          }
          & li.on a {
            color: var(--colBlack);
            font-weight: 600;
          }
        }
      }
    }
  }
  & > li::after {
    content: '';
    position: absolute;
    top: calc(50% - (14px / 2));
    right: 0;
    width: 1px;
    height: 14px;
    background: var(--colGray3);
  }
  & > li:last-child {
    padding-left: 12px;
  }
  & > li:last-child::after {
    display: none;
  }
`;

// 상품목록 영역 wrap
export const ProductWrap = styled.div<{ listType: string }>`
  font-size: 14px;
  display: grid;
  grid-template-columns: ${(props) => (props.listType === 'thumb' ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)')};
  grid-gap: ${(props) => (props.listType === 'thumb' ? '30px 12px' : '16px')};

  @media screen and (min-width: 768px) {
    grid-template-columns: ${(props) => (props.listType === 'thumb' ? 'repeat(4, 1fr)' : 'repeat(1, 1fr)')};
    grid-gap: 48px 16px;
    margin-bottom: 84px;
  }
`;
